import { toast } from "react-toastify";
import FiscalYear from "models/fiscal-year";
import FiscalYearFields from "Components/organisms/forms/fiscal-year-form/types";

/** Every fiscal year, hidden included, with its period count. Admin screen only. */
export const getAllFiscalYears = async (): Promise<FiscalYear[] | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/fiscal-years?includeHidden=true`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'GET',
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        const data = await res.json();
        return data.data as FiscalYear[];
    } catch (err: any) {
        toast.error(err.message ?? "Error getting Fiscal Years");
        return null;
    }
}

export const submitCreateFiscalYearForm = async (
    vals: FiscalYearFields
): Promise<FiscalYear | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/fiscal-years`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'POST',
            body: JSON.stringify({ id: Number(vals.year) }),
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        toast.success("Fiscal Year created.");
        const data = await res.json();
        return data.data;
    } catch (err: any) {
        toast.error(err.message ?? "Error creating Fiscal Year");
        return null;
    }
}

export const setFiscalYearHiddenRequest = async (
    fiscalYear: number,
    hide: boolean
): Promise<FiscalYear | null> => {
    try {
        const url = `${process.env.REACT_APP_API_URL}/fiscal-years/${fiscalYear}`;

        const res = await fetch(url, {
            credentials: 'include',
            method: 'PATCH',
            body: JSON.stringify({ hide }),
            headers: {
                'Content-Type': 'application/json',
            }
        });

        if (!res.ok) {
            const errBody = await res.json();
            throw new Error(errBody.message);
        }

        toast.success(hide ? `Fiscal Year ${fiscalYear} hidden.` : `Fiscal Year ${fiscalYear} is visible.`);
        const data = await res.json();
        return data.data;
    } catch (err: any) {
        toast.error(err.message ?? "Error updating Fiscal Year");
        return null;
    }
}
